import http from '../../../../../http/base';
import { API_PATHS } from '../../../../../http/configs';

export function getCalculatedDues(partnerId, startingDateToCalculate) {
    return http.get(API_PATHS.getCalculatedDues, { params: { partnerId, startingDateToCalculate } });
};